import { useStore } from '@priolo/jon'
import FindField from 'components/controls/fields/FindField'
import Root2Icon from 'images/menu/root2'
import { FunctionComponent, useMemo } from 'react'
import agentSo from 'stores/agent'
import biSo from 'stores/bi'
import dialogSo, { DIALOG_TYPE } from 'stores/layout/dialogStore'
import querySo from 'stores/route/query'
import { URL_PAR } from 'stores/route/utils/types'



const SearchField: FunctionComponent = () => {

	// STORE
	useStore(querySo)

	// HOOKs

	// HANDLERs
	const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		querySo.setSearchUrl([URL_PAR.TEXT, e.target.value])
	}
	const handleAIClick = async () => {
		let [prompt] = querySo.getSearchUrl([URL_PAR.TEXT])
		const { fn, description } = await agentSo.run(prompt)

		let indexes = fn(biSo.state.data)
		indexes = !!indexes ? indexes.filter(i => i >= 0 && i < biSo.state.data.length) : []

		biSo.setPropertiesFound(indexes)

		dialogSo.dialogOpen({
			modal: false,
			type: indexes.length == 0 ? DIALOG_TYPE.WARNING : null,
			text: `${description}\n${indexes.length == 0 ? "NO ITEMS SELECTED" : `SELECTED ITEMS: ${indexes.length}`}`,
		})
	}
	
	// const _handleAIClick = async () => {

	// 	//const prompt = "select all items that have yield greater 300"
	// 	let [prompt, dateRangeUrl] = querySo.getSearchUrl([URL_PAR.TEXT, URL_PAR.DATE_SEL])
	// 	//const indexes:number[] = await aiRun(biSo.state.data, prompt)

	// 	let def: { functionJs: string, description: string } = await aiRun(prompt)
	// 	//def = def.startsWith('"') ? def.slice(1,-1) : def
	// 	console.log(def.functionJs)
	// 	console.log("--------------------")
	// 	console.log(def.description)
	// 	console.log("--------------------")

	// 	//const select:(item:any, array:any[]) => boolean = new Function(`return ${def}`)()
	// 	const select: (array: any[]) => number[] = new Function(`return ${def.functionJs}`)()

	// 	// let indexes = biSo.state.data.reduce((acc, item, index) => {
	// 	// 	if (select(item, biSo.state.data)) acc.push(index)
	// 	// 	return acc
	// 	// }, [])
	// 	let indexes = select(biSo.state.data)
	// 	indexes = !!indexes ? indexes.filter(i => i >= 0 && i < biSo.state.data.length) : []

	// 	biSo.setPropertiesFound(indexes)

	// 	dialogSo.dialogOpen({
	// 		modal: false,
	// 		type: indexes.length == 0 ? DIALOG_TYPE.WARNING : null,
	// 		text: `${def.description}${indexes.length == 0 ? "\nNO ITEMS FOUND" : ""}`,
	// 	})
	// }

	// RENDER
	const [text] = useMemo(() => querySo.getSearchUrl([URL_PAR.TEXT]), [querySo.state.queryUrl])

	return (
		<FindField sx={{ flex: 1 }}
			value={text ?? ""}
			onChange={handleTextChange}
			endRender={<Root2Icon onClick={handleAIClick}/>}
			placeholder='Search in all data values'
		/>
	)
}

export default SearchField

